<template>
	<div>
		<div style="display: flex;">
			<div style="flex: 1;font-weight: 800;font-size: 18px;">调店时间为所选时间的0点</div>
			<div style="width: 100%;text-align: right;margin-bottom: 10px;flex: 5;">
				<el-button type="primary" @click="add()">新建</el-button>
			</div>
		</div>
		<el-table :data="data" :header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
			:cell-style="{'text-align':'center'}">
			<el-table-column prop="id" label="id" width="100px"></el-table-column>
			<el-table-column label="调店日期">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">
						每{{row | m}}
					</div>
					<div v-else>
						<el-select v-model="row.timeType" style="width: 120px;">
							<el-option v-for="i in timeTypeList" :key="i.id" :value="i.id" :label="i.label"></el-option>
						</el-select>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="workerName" label="发型师">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">
						<div>
							<el-image :src="row.avatar" style="width: 75px; height: 75px;border-radius: 50px;" />
						</div>
						<div>
							{{row.workerName}}
						</div>
					</div>
					<div v-else>
						<el-select v-model="row.workerId" filterable class="w100">
							<el-option v-for="i in workList" :key="i.id" :value="i.id" :label="i.name"></el-option>
						</el-select>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="storeName" label="门店">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">
						{{row.storeName}}
					</div>
					<div v-else>
						<el-select v-model="row.storeId" class="w100">
							<el-option v-for="i in storeList" :key="i.id" :value="i.id" :label="i.title">{{i.title}}
							</el-option>
						</el-select>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="haircutPrice" label="剪发价格">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">￥{{row.haircutPrice}}</div>
					<el-input v-else v-model="row.haircutPrice" class="w100"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="childPrice" label="儿童剪发价格">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">￥{{row.childPrice}}</div>
					<el-input v-else v-model="row.childPrice" class="w100"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{row}">
					<div style="display: flex;margin-left: 50px;">
						<el-button v-if="row.edit==false" size="small" type="primary" @click="edit(row)">修改</el-button>
						<el-button v-else size="small" type="primary" @click="save(row)">保存</el-button>
						<el-button size="small" type="danger" @click="remove(row.id,index)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	const that = this
	export default {
		data() {
			return {
				data: [],
				workList: [],
				storeList: [],
				timeTypeList: [{
					id: 0,
					label: '周日'
				}, {
					id: 1,
					label: '周一'
				}, {
					id: 2,
					label: '周二'
				}, {
					id: 3,
					label: '周三'
				}, {
					id: 4,
					label: '周四'
				}, {
					id: 5,
					label: '周五'
				}, {
					id: 6,
					label: '周六'
				}, ]
			}
		},
		filters: {
			m(val) {
				switch (val.timeType) {
					case 0:
						return '周日'
					case 1:
						return '周一'
					case 2:
						return '周二'
					case 3:
						return '周三'
					case 4:
						return '周四'
					case 5:
						return '周五'
					case 6:
						return '周六'
				}
				// that.timeTypeList.forEach(time => {
				// 	if (time.id == val) {
				// 		return time.label
				// 	} else {
				// 		return '未知'
				// 	}
				// })
			}
		},
		mounted() {
			this.getList()
			this.getWorkerList()
			this.getStoreList()
		},
		methods: {
			getList() {
				this.$http.get("dWorkerChangeStore/list").then(res => {
					if (res.body.code == 200) {
						this.data = res.body.data
						this.data.forEach(d => {
							d.haircutPrice = (d.haircutPrice / 100).toFixed(2)
							d.childPrice = (d.childPrice / 100).toFixed(2)
							this.$set(d, "edit", false)
						})
					}
				})
			},
			getWorkerList() {
				var query = "page=0&size=999&status=3"
				this.$http.get("dWorker/queryAll?" + query).then(res => {
					// this.workList = res.body.data.records.filter(e => e.test==0);
					this.workList = res.body.data.records;
				});
			},
			getStoreList() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType != 1) {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			save(item) {
				if (item.workerId == '') {
					this.$message.info("请选择发型师")
					return
				}
				if (item.timeType == null) {
					this.$message.info("请选择调店日期")
					return
				}
				var a = {
					id: item.id,
					workerId: item.workerId,
					storeId: item.storeId,
					timeType: item.timeType,
					haircutPrice: item.haircutPrice * 100,
					childPrice: item.childPrice * 100
				}
				this.$http.post("dWorkerChangeStore/save", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
					} else {
						this.$message.error("失败")
					}
					this.getList()
				})
			},
			edit(row) {
				row.edit = true
			},
			add() {
				var a = {
					workerId: '',
					storeId: '',
					timeType: 0,
					haircutPrice: '',
					childPrice: ''
				}
				this.data.unshift(a)
			},
			remove(id, index) {
				if (id == null || id == '') {
					this.data.splice(index, 1)
					this.$message.success("删除成功")
				} else {
					this.$http.get("dWorkerChangeStore/remove?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.getList()
							this.$message.success("删除成功")
						}
					})
				}
			}
		}
	}
</script>

<style>
	.w100 {
		width: 120px;
	}
</style>